import React, { useMemo } from 'react';

import { NestedWaypointRendererProvider, useEvalLiquid } from '@wp-block-builder/stores/WaypointRendererStore';

function getCastString(v: string | null | undefined, defaultValue: string): string {
  if (v === null || v === undefined || v.trim().length === 0) {
    return defaultValue;
  }
  return v.trim();
}

type Props = {
  placeholder: JSX.Element | null;
  loopTemplate: string | null | undefined;
  loopArgumentName: string | null | undefined;
  loopIndexName: string | null | undefined;
  renderLoopIteration: (index: number) => JSX.Element;
};

export default function LoopRunner({
  placeholder,
  loopTemplate,
  loopArgumentName,
  loopIndexName,
  renderLoopIteration,
}: Props) {
  const evalValue = useEvalLiquid();

  const loopArray = useMemo(() => {
    if (loopTemplate === null || loopTemplate === undefined || loopTemplate.trim().length === 0) {
      return null;
    }
    const v = evalValue(loopTemplate);
    if (!Array.isArray(v) || v.length === 0) {
      return null;
    }

    return v;
  }, [evalValue, loopTemplate]);

  if (!loopArray) {
    return placeholder;
  }

  return (
    <>
      {loopArray.map((value, index) => (
        <NestedWaypointRendererProvider
          key={index}
          value={value}
          valueName={getCastString(loopArgumentName, 'val')}
          index={index}
          indexName={getCastString(loopIndexName, 'val')}
        >
          {renderLoopIteration(index)}
        </NestedWaypointRendererProvider>
      ))}
    </>
  );
}
